import createDOMPurify from 'dompurify';
import { ALLOWED_RICH_TAGS, ALLOWED_RICH_ATTR } from './pasteUtils';

const DOMPurify = createDOMPurify(window);

/**
 * Strips HTML tags for use in plain-text contexts (e.g. truncated previews).
 */
export const stripHtml = (html) => {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
};

const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ALLOWED_RICH_TAGS,
  ALLOWED_ATTR: ALLOWED_RICH_ATTR,
};

const isHtml = (str) => /<[a-z][\s\S]*>/i.test(str);

export const sanitizeDescription = (description) => {
  if (!description) return '';
  if (isHtml(description)) return DOMPurify.sanitize(description, SANITIZE_CONFIG);
  return description.replace(/\n/g, '<br>');
};
